export * from './shared';
export * from './client';

/** A type useful for when you want to create a `React.FC` with a specific return type */
export type SpecificRFC<
    Props extends Record<string, unknown>,
    ReturnType extends React.ReactNode,
> = (props: Props) => ReturnType;
